import { ShowOrgFunctionRequestSchema, ShowOrgFunctionResponseSchema } from './show-org-function.schema';
/**
 * Show OrgFunction Endpoint Contract
 * Retrieves a specific OrgFunction by ID
 */ export const showOrgFunctionContract = {
    method: 'GET',
    path: '/api/v2/org-function/:id',
    description: 'Retrieve a specific OrgFunction by ID',
    requestSchema: ShowOrgFunctionRequestSchema,
    responseSchema: ShowOrgFunctionResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'OrgFunction not found'
        }
    }
};

//# sourceMappingURL=show-org-function.contract.js.map